import WebAssetOffIcon from '@mui/icons-material/WebAssetOff';
import { Container, Grid, Typography } from '@mui/material';

export default function NotFound() {
  return (
    <Container>
      <Grid container alignItems="center" justifyContent="center" color="gray" gap="10px">
        <WebAssetOffIcon/>
        <Typography>404 Not found.</Typography>
      </Grid>
    </Container>
  );
}